'use client';

import dynamic from 'next/dynamic';

export const Amplitude = dynamic(() => import('@/lib/ampli'), {
  ssr: false,
});
